import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useGenerateInvoicesMutation } from 'queries/admin/charges'

type GenerateInvoiceFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
      data: ReturnType<typeof useGenerateInvoicesMutation>['data']
    }
  }
  actions: {
    submit: ReturnType<typeof useGenerateInvoicesMutation>['mutate']
    reset: ReturnType<typeof useGenerateInvoicesMutation>['reset']
  }
}

const [Context, useGenerateInvoiceFlowContextValue] =
  createContext<GenerateInvoiceFlowContextState>({
    name: 'GenerateInvoiceFlowContext',
  })

export const GenerateInvoiceFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error, data } =
    useGenerateInvoicesMutation()

  const value: GenerateInvoiceFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
        data,
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useGenerateInvoiceFlowContextValue }
